import moment from 'moment';

export const sortBy = {
  'e-Receipt Total (High to Low)': (a: Object, b: Object) => b.total - a.total,
  'e-Receipt Total (Low to High)': (a: Object, b: Object) => a.total - b.total,
  'Date (New to Old)': (a: Object, b: Object) => {
    const first = moment(a.date);
    const second = moment(b.date);

    if (first.isSame(second)) {
      return 0;
    }
    return first.isBefore(second) ? 1 : -1;
  },
  'Date (Old to New)': (a: Object, b: Object) => {
    const first = moment(a.date);
    const second = moment(b.date);

    if (first.isSame(second)) {
      return 0;
    }

    return first.isAfter(second) ? 1 : -1;
  },
};

export const sorts = [
  'Date (New to Old)',
  'Date (Old to New)',
  'e-Receipt Total (High to Low)',
  'e-Receipt Total (Low to High)',
];
